import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

/** override the defaults from reactDataGrid.styl */
export const projectPickerStyles = style({
  $nest: {
    '& .tb-react-dg-bcell': { paddingLeft: 0, paddingRight: 0 }
  }
});

/** make the project picker look like an input field, e.g. if it's next to some other input fields */
export const projectPickerFieldStyles = style({
  border: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.F5)}`,
  borderRadius: 1,
  position: 'relative',
  $nest: {
    '&:hover': { borderColor: applyColor(DesignTokens.color.elevation.border.default.medium, TabStyles.Colors.F9) },
  }
});
